// AVTO-GENERATSIYA (scripts/gen-screens.py) tz/admin/GROM_Admin_Panel_TZ.md dan.
// 28 modul / 614 ekran registri — panel navigatsiyasi va modul-index shu manbadan.
// Qo'lda tahrirlanmaydi; TZ o'zgarsa qayta generatsiya qilinadi.

export interface ScreenDef {
  id: string
  title: string
}
export interface ModuleDef {
  key: string
  num: number
  title: string
  count: number
  screens: ScreenDef[]
}

export const MODULES: ModuleDef[] = [
  {
    "key": "A1",
    "num": 1,
    "title": "Autentifikatsiya va kirish",
    "count": 8,
    "screens": [
      {
        "id": "A1.01",
        "title": "Kirish"
      },
      {
        "id": "A1.02",
        "title": "Hardware 2FA"
      },
      {
        "id": "A1.03",
        "title": "Qurilma ro'yxatdan o'tkazish"
      },
      {
        "id": "A1.04",
        "title": "Break-glass kirish"
      },
      {
        "id": "A1.05",
        "title": "Sessiya muddati tugadi"
      },
      {
        "id": "A1.06",
        "title": "IP cheklovi rad etdi"
      },
      {
        "id": "A1.07",
        "title": "Rol tanlash"
      },
      {
        "id": "A1.08",
        "title": "Xush kelibsiz / onboarding"
      }
    ]
  },
  {
    "key": "A2",
    "num": 2,
    "title": "Bosh sahifa (Dashboard)",
    "count": 12,
    "screens": [
      {
        "id": "A2.01",
        "title": "Umumiy dashboard (rolga moslashadi)"
      },
      {
        "id": "A2.02",
        "title": "Real-time monitor (jonli hisoblagichlar: onlayn, xabar/s, ro'yxat/daq)"
      },
      {
        "id": "A2.03",
        "title": "Moderatsiya dashboard'i"
      },
      {
        "id": "A2.04",
        "title": "Moliya dashboard'i"
      },
      {
        "id": "A2.05",
        "title": "Infratuzilma dashboard'i"
      },
      {
        "id": "A2.06",
        "title": "O'sish (growth) dashboard'i"
      },
      {
        "id": "A2.07",
        "title": "Support dashboard'i"
      },
      {
        "id": "A2.08",
        "title": "Xavfsizlik dashboard'i"
      },
      {
        "id": "A2.09",
        "title": "Mening vazifalarim (shaxsiy navbat)"
      },
      {
        "id": "A2.10",
        "title": "Ogohlantirishlar markazi (barcha alert'lar)"
      },
      {
        "id": "A2.11",
        "title": "Dashboard konstruktori (widget drag-and-drop)"
      },
      {
        "id": "A2.12",
        "title": "Ekran rejimi (TV panel uchun, katta raqamlar)"
      }
    ]
  },
  {
    "key": "A3",
    "num": 3,
    "title": "Foydalanuvchilar",
    "count": 38,
    "screens": [
      {
        "id": "A3.01",
        "title": "Foydalanuvchilar ro'yxati (virtualizatsiyalangan jadval)"
      },
      {
        "id": "A3.02",
        "title": "Kengaytirilgan qidiruv (20+ filtr)"
      },
      {
        "id": "A3.03",
        "title": "Saqlangan filtrlar / segmentlar"
      },
      {
        "id": "A3.04",
        "title": "Ommaviy amallar (bulk)"
      },
      {
        "id": "A3.05",
        "title": "Eksport (CSV/XLSX, four-eyes)"
      },
      {
        "id": "A3.06",
        "title": "Import (test muhiti uchun)"
      },
      {
        "id": "A3.07",
        "title": "Umumiy ma'lumot"
      },
      {
        "id": "A3.08",
        "title": "Profil tarixi (nom/username/avatar o'zgarishlari)"
      },
      {
        "id": "A3.09",
        "title": "Aloqa ma'lumotlari (L2/L3, sabab bilan ochiladi)"
      },
      {
        "id": "A3.10",
        "title": "Sessiyalar va qurilmalar"
      },
      {
        "id": "A3.11",
        "title": "Kirish tarixi (IP, geo, qurilma)"
      },
      {
        "id": "A3.12",
        "title": "Chatlar ro'yxati (metama'lumot, kontentsiz)"
      },
      {
        "id": "A3.13",
        "title": "Egalik qilgan guruh/kanallar"
      },
      {
        "id": "A3.14",
        "title": "Egalik qilgan botlar"
      },
      {
        "id": "A3.15",
        "title": "To'lovlar tarixi"
      },
      {
        "id": "A3.16",
        "title": "Stars tranzaksiyalari"
      },
      {
        "id": "A3.17",
        "title": "Shikoyatlar (undan va unga qarshi)"
      },
      {
        "id": "A3.18",
        "title": "Strike va cheklovlar tarixi"
      },
      {
        "id": "A3.19",
        "title": "Moderatsiya izohlari (ichki)"
      },
      {
        "id": "A3.20",
        "title": "Support tiketlari"
      },
      {
        "id": "A3.21",
        "title": "Bog'liq akkauntlar (IP/qurilma/to'lov bo'yicha graf)"
      },
      {
        "id": "A3.22",
        "title": "Risk skori va signal'lar"
      },
      {
        "id": "A3.23",
        "title": "PII kirish jurnali (kim, qachon, nima uchun ko'rgan)"
      },
      {
        "id": "A3.24",
        "title": "Ma'lumot eksporti (GDPR so'rovi bo'yicha)"
      },
      {
        "id": "A3.25",
        "title": "Xabarlarni ko'rish (L4 — huquqiy so'rov + four-eyes)"
      },
      {
        "id": "A3.26",
        "title": "Ogohlantirish yuborish"
      },
      {
        "id": "A3.27",
        "title": "Cheklov qo'yish (strike)"
      },
      {
        "id": "A3.28",
        "title": "Bloklash (muddatli / doimiy)"
      },
      {
        "id": "A3.29",
        "title": "Blokdan chiqarish"
      },
      {
        "id": "A3.30",
        "title": "Shadowban (spam uchun, foydalanuvchi bilmaydi)"
      },
      {
        "id": "A3.31",
        "title": "Majburiy chiqarish (barcha sessiyalar)"
      },
      {
        "id": "A3.32",
        "title": "Username majburan o'zgartirish"
      },
      {
        "id": "A3.33",
        "title": "Avatar/nom o'chirish"
      },
      {
        "id": "A3.34",
        "title": "Akkauntni o'chirish (ma'muriy)"
      },
      {
        "id": "A3.35",
        "title": "Akkauntni tiklash"
      },
      {
        "id": "A3.36",
        "title": "Premium/Stars berish (kompensatsiya)"
      },
      {
        "id": "A3.37",
        "title": "Impersonation (debug uchun, faqat test muhiti)"
      },
      {
        "id": "A3.38",
        "title": "Xodim izohini qo'shish"
      }
    ]
  },
  {
    "key": "A4",
    "num": 4,
    "title": "Guruhlar, kanallar, forumlar",
    "count": 32,
    "screens": [
      {
        "id": "A4.01",
        "title": "Chatlar ro'yxati"
      },
      {
        "id": "A4.02",
        "title": "Kengaytirilgan qidiruv"
      },
      {
        "id": "A4.03",
        "title": "Ommaviy amallar"
      },
      {
        "id": "A4.04",
        "title": "Chat kartasi — umumiy"
      },
      {
        "id": "A4.05",
        "title": "A'zolar ro'yxati"
      },
      {
        "id": "A4.06",
        "title": "Adminlar va huquqlar"
      },
      {
        "id": "A4.07",
        "title": "Sozlamalar snapshot'i"
      },
      {
        "id": "A4.08",
        "title": "Taklif havolalari"
      },
      {
        "id": "A4.09",
        "title": "Qo'shilish so'rovlari"
      },
      {
        "id": "A4.10",
        "title": "Forum topiclari"
      },
      {
        "id": "A4.11",
        "title": "Bog'langan chatlar"
      },
      {
        "id": "A4.12",
        "title": "Ulangan botlar"
      },
      {
        "id": "A4.13",
        "title": "Kontent (oxirgi postlar, metama'lumot)"
      },
      {
        "id": "A4.14",
        "title": "Media galereya (moderatsiya rejimi)"
      },
      {
        "id": "A4.15",
        "title": "Pinned/muhim xabarlar"
      },
      {
        "id": "A4.16",
        "title": "O'sish grafigi"
      },
      {
        "id": "A4.17",
        "title": "Statistika (o'sish, qamrov)"
      },
      {
        "id": "A4.18",
        "title": "Reklama postlari"
      },
      {
        "id": "A4.19",
        "title": "Boost holati"
      },
      {
        "id": "A4.20",
        "title": "Monetizatsiya"
      },
      {
        "id": "A4.21",
        "title": "Shikoyatlar"
      },
      {
        "id": "A4.22",
        "title": "Moderatsiya tarixi"
      },
      {
        "id": "A4.23",
        "title": "Ogohlantirish yuborish"
      },
      {
        "id": "A4.24",
        "title": "Cheklov qo'yish"
      },
      {
        "id": "A4.25",
        "title": "Ommaviy postni o'chirish"
      },
      {
        "id": "A4.26",
        "title": "Kanalni yashirish (qidiruvdan)"
      },
      {
        "id": "A4.27",
        "title": "Kanalni bloklash"
      },
      {
        "id": "A4.28",
        "title": "Egalik o'tkazish (ma'muriy)"
      },
      {
        "id": "A4.29",
        "title": "Verifikatsiya berish/olib tashlash"
      },
      {
        "id": "A4.30",
        "title": "Username majburan bo'shatish"
      },
      {
        "id": "A4.31",
        "title": "Chatni arxivlash"
      },
      {
        "id": "A4.32",
        "title": "Chatni o'chirish"
      }
    ]
  },
  {
    "key": "A5",
    "num": 5,
    "title": "Botlar va Mini App'lar",
    "count": 30,
    "screens": [
      {
        "id": "A5.01",
        "title": "Botlar ro'yxati"
      },
      {
        "id": "A5.02",
        "title": "Bot kartasi"
      },
      {
        "id": "A5.03",
        "title": "Egasi va tarix"
      },
      {
        "id": "A5.04",
        "title": "Statistika (MAU, xabarlar)"
      },
      {
        "id": "A5.05",
        "title": "API foydalanish (chaqiruvlar, xatolar)"
      },
      {
        "id": "A5.06",
        "title": "Webhook holati"
      },
      {
        "id": "A5.07",
        "title": "Rate limit sozlamalari (individual)"
      },
      {
        "id": "A5.08",
        "title": "Shikoyatlar"
      },
      {
        "id": "A5.09",
        "title": "Token tarixi (revoke'lar)"
      },
      {
        "id": "A5.10",
        "title": "Buyruqlar va sozlamalar snapshot"
      },
      {
        "id": "A5.11",
        "title": "Botni cheklash"
      },
      {
        "id": "A5.12",
        "title": "Botni bloklash"
      },
      {
        "id": "A5.13",
        "title": "Botni o'chirish"
      },
      {
        "id": "A5.14",
        "title": "Rasmiy bot belgisi berish"
      },
      {
        "id": "A5.15",
        "title": "Bot limitini oshirish (VIP)"
      },
      {
        "id": "A5.16",
        "title": "Mini App'lar ro'yxati"
      },
      {
        "id": "A5.17",
        "title": "Mini App kartasi"
      },
      {
        "id": "A5.18",
        "title": "Moderatsiya navbati (yangi ilovalar)"
      },
      {
        "id": "A5.19",
        "title": "URL xavfsizlik tekshiruvi"
      },
      {
        "id": "A5.20",
        "title": "Skrinshot/preview ko'rish"
      },
      {
        "id": "A5.21",
        "title": "Katalogga qo'shish/olib tashlash"
      },
      {
        "id": "A5.22",
        "title": "Kategoriya va teg'lar"
      },
      {
        "id": "A5.23",
        "title": "Reyting va sharhlar moderatsiyasi"
      },
      {
        "id": "A5.24",
        "title": "Ilovani to'xtatish"
      },
      {
        "id": "A5.25",
        "title": "Ilovani o'chirish"
      },
      {
        "id": "A5.26",
        "title": "O'yinlar ro'yxati"
      },
      {
        "id": "A5.27",
        "title": "O'yin kartasi + leaderboard"
      },
      {
        "id": "A5.28",
        "title": "Business bot ulanishlari"
      },
      {
        "id": "A5.29",
        "title": "Affiliate dasturlari"
      },
      {
        "id": "A5.30",
        "title": "Bot API kalitlari monitoringi"
      }
    ]
  },
  {
    "key": "A6",
    "num": 6,
    "title": "Kontent moderatsiyasi",
    "count": 42,
    "screens": [
      {
        "id": "A6.01",
        "title": "Umumiy moderatsiya navbati"
      },
      {
        "id": "A6.02",
        "title": "Prioritetli navbat (yuqori xavf)"
      },
      {
        "id": "A6.03",
        "title": "CSAM navbati (izolyatsiyalangan, `csam_specialist` uchun)"
      },
      {
        "id": "A6.04",
        "title": "Zo'ravonlik / terrorizm navbati"
      },
      {
        "id": "A6.05",
        "title": "Spam navbati"
      },
      {
        "id": "A6.06",
        "title": "Firibgarlik navbati"
      },
      {
        "id": "A6.07",
        "title": "Mualliflik huquqi (DMCA) navbati"
      },
      {
        "id": "A6.08",
        "title": "Shaxsiy ma'lumot (doxxing) navbati"
      },
      {
        "id": "A6.09",
        "title": "Bot/Mini App moderatsiyasi"
      },
      {
        "id": "A6.10",
        "title": "Stiker/emoji moderatsiyasi"
      },
      {
        "id": "A6.11",
        "title": "Username moderatsiyasi (spoofing)"
      },
      {
        "id": "A6.12",
        "title": "Avatar/rasm moderatsiyasi"
      },
      {
        "id": "A6.13",
        "title": "Mening navbatim (shaxsiy)"
      },
      {
        "id": "A6.14",
        "title": "Ikkinchi ko'rib chiqish (appeal) navbati"
      },
      {
        "id": "A6.15",
        "title": "Kontent ko'ruvchi (blur bilan, klik ochadi)"
      },
      {
        "id": "A6.16",
        "title": "Kontekst ko'rinishi (atrofdagi xabarlar)"
      },
      {
        "id": "A6.17",
        "title": "Foydalanuvchi tarixi (yon panel)"
      },
      {
        "id": "A6.18",
        "title": "O'xshash holatlar (ML klasterlash)"
      },
      {
        "id": "A6.19",
        "title": "Qaror formasi (tugmalar + sabab)"
      },
      {
        "id": "A6.20",
        "title": "Ommaviy qaror (bir xil kontent guruhi)"
      },
      {
        "id": "A6.21",
        "title": "Eskalatsiya"
      },
      {
        "id": "A6.22",
        "title": "Ikkinchi fikr so'rash"
      },
      {
        "id": "A6.23",
        "title": "ML modellar ro'yxati va holati"
      },
      {
        "id": "A6.24",
        "title": "Model ishlash sifati (precision/recall)"
      },
      {
        "id": "A6.25",
        "title": "Chegaralar (threshold) sozlash"
      },
      {
        "id": "A6.26",
        "title": "Hash bazasi (ma'lum zararli kontent)"
      },
      {
        "id": "A6.27",
        "title": "Perceptual hash qidiruvi"
      },
      {
        "id": "A6.28",
        "title": "Kalit so'zlar ro'yxatlari"
      },
      {
        "id": "A6.29",
        "title": "Regex qoidalari"
      },
      {
        "id": "A6.30",
        "title": "Havola/domen qora ro'yxati"
      },
      {
        "id": "A6.31",
        "title": "Fayl hash qora ro'yxati (zararli APK reyestri)"
      },
      {
        "id": "A6.32",
        "title": "Oq ro'yxatlar (false positive'ni oldini olish)"
      },
      {
        "id": "A6.33",
        "title": "Qoidalar konstruktori (if-then)"
      },
      {
        "id": "A6.34",
        "title": "Qoida testi (tarixiy ma'lumotda)"
      },
      {
        "id": "A6.35",
        "title": "Avtomatik qarorlar jurnali"
      },
      {
        "id": "A6.36",
        "title": "Moderatorlar statistikasi"
      },
      {
        "id": "A6.37",
        "title": "Qarorlar auditi (tasodifiy tanlov)"
      },
      {
        "id": "A6.38",
        "title": "Kelishuv darajasi (inter-rater agreement)"
      },
      {
        "id": "A6.39",
        "title": "Xato qarorlar tahlili"
      },
      {
        "id": "A6.40",
        "title": "O'quv rejimi (yangi moderator, real qaror qabul qilmaydi)"
      },
      {
        "id": "A6.41",
        "title": "Moderatsiya siyosati (ichki qo'llanma)"
      },
      {
        "id": "A6.42",
        "title": "Shaffoflik hisoboti generatori"
      }
    ]
  },
  {
    "key": "A7",
    "num": 7,
    "title": "Shikoyatlar va tiketlar",
    "count": 24,
    "screens": [
      {
        "id": "A7.01",
        "title": "Shikoyatlar ro'yxati"
      },
      {
        "id": "A7.02",
        "title": "Shikoyat kartasi"
      },
      {
        "id": "A7.03",
        "title": "Guruhlash (bir obyektga ko'p shikoyat)"
      },
      {
        "id": "A7.04",
        "title": "Shikoyatchi ishonchliligi"
      },
      {
        "id": "A7.05",
        "title": "Asossiz shikoyatlar"
      },
      {
        "id": "A7.06",
        "title": "Support tiketlari"
      },
      {
        "id": "A7.07",
        "title": "Tiket kartasi"
      },
      {
        "id": "A7.08",
        "title": "Yozishmalar tarixi"
      },
      {
        "id": "A7.09",
        "title": "Tayinlash va navbat"
      },
      {
        "id": "A7.10",
        "title": "Prioritet boshqaruvi"
      },
      {
        "id": "A7.11",
        "title": "Teg va kategoriyalar"
      },
      {
        "id": "A7.12",
        "title": "Birlashtirish (duplikatlar)"
      },
      {
        "id": "A7.13",
        "title": "SLA monitoringi"
      },
      {
        "id": "A7.14",
        "title": "Kechikkan tiketlar"
      },
      {
        "id": "A7.15",
        "title": "Javob shablonlari"
      },
      {
        "id": "A7.16",
        "title": "Makroslar (bir klikda javob+amal)"
      },
      {
        "id": "A7.17",
        "title": "Eskalatsiya qoidalari"
      },
      {
        "id": "A7.18",
        "title": "Ichki muhokama (tiket ichida)"
      },
      {
        "id": "A7.19",
        "title": "Bilim bazasi"
      },
      {
        "id": "A7.20",
        "title": "Avtomatik javoblar"
      },
      {
        "id": "A7.21",
        "title": "CSAT so'rovnomasi"
      },
      {
        "id": "A7.22",
        "title": "Agent statistikasi"
      },
      {
        "id": "A7.23",
        "title": "Jamoa yuklamasi"
      },
      {
        "id": "A7.24",
        "title": "Tiket hisobotlari"
      }
    ]
  },
  {
    "key": "A8",
    "num": 8,
    "title": "Strike, ban va apellyatsiya",
    "count": 20,
    "screens": [
      {
        "id": "A8.01",
        "title": "Aktiv cheklovlar ro'yxati"
      },
      {
        "id": "A8.02",
        "title": "Strike tarixi"
      },
      {
        "id": "A8.03",
        "title": "Strike qoidalari (5 daraja)"
      },
      {
        "id": "A8.04",
        "title": "Avtomatik cheklov qoidalari"
      },
      {
        "id": "A8.05",
        "title": "Qo'lda cheklov qo'yish"
      },
      {
        "id": "A8.06",
        "title": "Cheklovni bekor qilish"
      },
      {
        "id": "A8.07",
        "title": "Muddatni o'zgartirish"
      },
      {
        "id": "A8.08",
        "title": "Ommaviy cheklov (spam to'lqini)"
      },
      {
        "id": "A8.09",
        "title": "Cheklov shablonlari"
      },
      {
        "id": "A8.10",
        "title": "Apellyatsiyalar navbati"
      },
      {
        "id": "A8.11",
        "title": "Apellyatsiya kartasi"
      },
      {
        "id": "A8.12",
        "title": "Apellyatsiya qarori"
      },
      {
        "id": "A8.13",
        "title": "Ommaviy amnistiya"
      },
      {
        "id": "A8.14",
        "title": "Noto'g'ri ban tahlili"
      },
      {
        "id": "A8.15",
        "title": "Ban sabablari katalogi"
      },
      {
        "id": "A8.16",
        "title": "IP/qurilma bloklari"
      },
      {
        "id": "A8.17",
        "title": "Telefon raqam bloklari"
      },
      {
        "id": "A8.18",
        "title": "Qayta ro'yxatdan o'tishni oldini olish"
      },
      {
        "id": "A8.19",
        "title": "Cheklov statistikasi"
      },
      {
        "id": "A8.20",
        "title": "Adolat hisoboti (ban/unban nisbati)"
      }
    ]
  },
  {
    "key": "A9",
    "num": 9,
    "title": "Verifikatsiya",
    "count": 14,
    "screens": [
      {
        "id": "A9.01",
        "title": "Arizalar navbati"
      },
      {
        "id": "A9.02",
        "title": "Ariza kartasi"
      },
      {
        "id": "A9.03",
        "title": "Hujjatlarni ko'rish"
      },
      {
        "id": "A9.04",
        "title": "Domen tasdig'i tekshiruvi"
      },
      {
        "id": "A9.05",
        "title": "Tashqi manbadan tekshirish"
      },
      {
        "id": "A9.06",
        "title": "Qaror (tasdiq/rad)"
      },
      {
        "id": "A9.07",
        "title": "Verifikatsiya berish"
      },
      {
        "id": "A9.08",
        "title": "Verifikatsiyani olib tashlash"
      },
      {
        "id": "A9.09",
        "title": "Uchinchi tomon verifikatorlar"
      },
      {
        "id": "A9.10",
        "title": "Verifikator sozlamalari (ikonka, kompaniya)"
      },
      {
        "id": "A9.11",
        "title": "Verifikator faoliyati auditi"
      },
      {
        "id": "A9.12",
        "title": "Verifikatsiyalanganlar reyestri"
      },
      {
        "id": "A9.13",
        "title": "Soxta verifikatsiya urinishlari"
      },
      {
        "id": "A9.14",
        "title": "Verifikatsiya statistikasi"
      }
    ]
  },
  {
    "key": "A10",
    "num": 10,
    "title": "Moliya, to'lovlar, Stars",
    "count": 36,
    "screens": [
      {
        "id": "A10.01",
        "title": "Barcha tranzaksiyalar"
      },
      {
        "id": "A10.02",
        "title": "Tranzaksiya kartasi"
      },
      {
        "id": "A10.03",
        "title": "Muvaffaqiyatsiz to'lovlar"
      },
      {
        "id": "A10.04",
        "title": "Kutilayotgan to'lovlar"
      },
      {
        "id": "A10.05",
        "title": "Provayder bo'yicha bo'linish"
      },
      {
        "id": "A10.06",
        "title": "Valyuta bo'yicha"
      },
      {
        "id": "A10.07",
        "title": "Davlat bo'yicha"
      },
      {
        "id": "A10.08",
        "title": "Stars emissiyasi va aylanmasi"
      },
      {
        "id": "A10.09",
        "title": "Stars balanslar taqsimoti"
      },
      {
        "id": "A10.10",
        "title": "Chargeback'lar"
      },
      {
        "id": "A10.11",
        "title": "Nizolar (dispute)"
      },
      {
        "id": "A10.12",
        "title": "Refund navbati"
      },
      {
        "id": "A10.13",
        "title": "Refund tasdiqlash (four-eyes)"
      },
      {
        "id": "A10.14",
        "title": "Ommaviy refund"
      },
      {
        "id": "A10.15",
        "title": "Qo'lda tranzaksiya (kompensatsiya)"
      },
      {
        "id": "A10.16",
        "title": "Tranzaksiya izlash (qidiruv)"
      },
      {
        "id": "A10.17",
        "title": "Solishtirish (reconciliation)"
      },
      {
        "id": "A10.18",
        "title": "Provayder bilan mos kelmaslik"
      },
      {
        "id": "A10.19",
        "title": "Yechish so'rovlari"
      },
      {
        "id": "A10.20",
        "title": "Yechishni tasdiqlash (four-eyes)"
      },
      {
        "id": "A10.21",
        "title": "Yechish tarixi"
      },
      {
        "id": "A10.22",
        "title": "Bot egalari daromadi"
      },
      {
        "id": "A10.23",
        "title": "Kanal monetizatsiyasi"
      },
      {
        "id": "A10.24",
        "title": "Affiliate to'lovlari"
      },
      {
        "id": "A10.25",
        "title": "Obunalar (recurring)"
      },
      {
        "id": "A10.26",
        "title": "Bekor qilingan obunalar"
      },
      {
        "id": "A10.27",
        "title": "Kohorta bo'yicha LTV"
      },
      {
        "id": "A10.28",
        "title": "Daromad hisoboti"
      },
      {
        "id": "A10.29",
        "title": "Komissiyalar hisoboti"
      },
      {
        "id": "A10.30",
        "title": "Soliq hisobotlari"
      },
      {
        "id": "A10.31",
        "title": "Buxgalteriya eksporti"
      },
      {
        "id": "A10.32",
        "title": "Provayder sozlamalari"
      },
      {
        "id": "A10.33",
        "title": "Komissiya stavkalari"
      },
      {
        "id": "A10.34",
        "title": "To'lov limitlari"
      },
      {
        "id": "A10.35",
        "title": "Test rejimi boshqaruvi"
      },
      {
        "id": "A10.36",
        "title": "Moliyaviy alert'lar"
      }
    ]
  },
  {
    "key": "A11",
    "num": 11,
    "title": "Geografiya va davlatlar",
    "count": 23,
    "screens": [
      {
        "id": "A11.01",
        "title": "Davlatlar xaritasi"
      },
      {
        "id": "A11.02",
        "title": "Davlatlar ro'yxati"
      },
      {
        "id": "A11.03",
        "title": "Davlat kartasi"
      },
      {
        "id": "A11.04",
        "title": "Davlatni yoqish/o'chirish"
      },
      {
        "id": "A11.05",
        "title": "Bosqichma-bosqich ochish"
      },
      {
        "id": "A11.06",
        "title": "Funksiya bo'yicha cheklov"
      },
      {
        "id": "A11.07",
        "title": "To'lov cheklovlari"
      },
      {
        "id": "A11.08",
        "title": "Kontent cheklovlari"
      },
      {
        "id": "A11.09",
        "title": "Til va mintaqa sozlamalari"
      },
      {
        "id": "A11.10",
        "title": "Telefon operatorlari"
      },
      {
        "id": "A11.11",
        "title": "Raqam prefikslari"
      },
      {
        "id": "A11.12",
        "title": "Bloklangan raqam diapazonlari"
      },
      {
        "id": "A11.13",
        "title": "IP geo-baza"
      },
      {
        "id": "A11.14",
        "title": "VPN/proxy aniqlash"
      },
      {
        "id": "A11.15",
        "title": "Tor tugunlari"
      },
      {
        "id": "A11.16",
        "title": "Hudud bo'yicha DC yo'naltirish"
      },
      {
        "id": "A11.17",
        "title": "Ma'lumot rezidentligi"
      },
      {
        "id": "A11.18",
        "title": "Sanksiya ro'yxatlari"
      },
      {
        "id": "A11.19",
        "title": "Huquqiy talablar reyestri"
      },
      {
        "id": "A11.20",
        "title": "Davlat bo'yicha o'sish"
      },
      {
        "id": "A11.21",
        "title": "Geo-anomaliyalar"
      },
      {
        "id": "A11.22",
        "title": "O'zgarishlar jurnali"
      },
      {
        "id": "A11.23",
        "title": "Davlat bo'yicha Premium narxlari"
      }
    ]
  },
  {
    "key": "A12",
    "num": 12,
    "title": "SEO va ommaviy veb",
    "count": 26,
    "screens": [
      {
        "id": "A12.01",
        "title": "SEO dashboard"
      },
      {
        "id": "A12.02",
        "title": "Meta teg shablonlari"
      },
      {
        "id": "A12.03",
        "title": "OpenGraph / Twitter Card"
      },
      {
        "id": "A12.04",
        "title": "Canonical URL qoidalari"
      },
      {
        "id": "A12.05",
        "title": "`robots.txt` muharriri"
      },
      {
        "id": "A12.06",
        "title": "`sitemap.xml` boshqaruvi"
      },
      {
        "id": "A12.07",
        "title": "Indekslash siyosati"
      },
      {
        "id": "A12.08",
        "title": "`noindex` ro'yxati"
      },
      {
        "id": "A12.09",
        "title": "Strukturaviy ma'lumot (Schema.org)"
      },
      {
        "id": "A12.10",
        "title": "Hreflang boshqaruvi"
      },
      {
        "id": "A12.11",
        "title": "Redirect'lar"
      },
      {
        "id": "A12.12",
        "title": "404 monitoringi"
      },
      {
        "id": "A12.13",
        "title": "Kalit so'zlar reyestri"
      },
      {
        "id": "A12.14",
        "title": "Raqobatchilar tahlili"
      },
      {
        "id": "A12.15",
        "title": "Kontent bo'shliqlari"
      },
      {
        "id": "A12.16",
        "title": "Ichki havolalar tahlili"
      },
      {
        "id": "A12.17",
        "title": "Core Web Vitals"
      },
      {
        "id": "A12.18",
        "title": "Sahifa tezligi"
      },
      {
        "id": "A12.19",
        "title": "Mobil moslik"
      },
      {
        "id": "A12.20",
        "title": "Search Console integratsiyasi"
      },
      {
        "id": "A12.21",
        "title": "Yandex Webmaster integratsiyasi"
      },
      {
        "id": "A12.22",
        "title": "Landing sahifalar konstruktori"
      },
      {
        "id": "A12.23",
        "title": "Blog / yangiliklar CMS"
      },
      {
        "id": "A12.24",
        "title": "Mini App katalogi SEO"
      },
      {
        "id": "A12.25",
        "title": "Deep-link preview sozlamalari"
      },
      {
        "id": "A12.26",
        "title": "SEO audit hisoboti"
      }
    ]
  },
  {
    "key": "A13",
    "num": 13,
    "title": "API kalitlari va dasturchilar",
    "count": 20,
    "screens": [
      {
        "id": "A13.01",
        "title": "`api_id` ilovalari ro'yxati"
      },
      {
        "id": "A13.02",
        "title": "Ilova kartasi"
      },
      {
        "id": "A13.03",
        "title": "Foydalanish statistikasi"
      },
      {
        "id": "A13.04",
        "title": "Rate limit sozlamalari"
      },
      {
        "id": "A13.05",
        "title": "Ilovani bloklash"
      },
      {
        "id": "A13.06",
        "title": "Suiiste'mol aniqlash"
      },
      {
        "id": "A13.07",
        "title": "Bot tokenlari monitoringi"
      },
      {
        "id": "A13.08",
        "title": "Sizib ketgan tokenlar (GitHub skanери)"
      },
      {
        "id": "A13.09",
        "title": "Majburiy revoke"
      },
      {
        "id": "A13.10",
        "title": "VIP limitlar"
      },
      {
        "id": "A13.11",
        "title": "Kalit rotatsiyasi jurnali"
      },
      {
        "id": "A13.12",
        "title": "Ichki servis kalitlari"
      },
      {
        "id": "A13.13",
        "title": "Shifrlash kalitlari (KMS)"
      },
      {
        "id": "A13.14",
        "title": "Kalit eksporti (four-eyes + HSM)"
      },
      {
        "id": "A13.15",
        "title": "Sertifikatlar (TLS) monitoringi"
      },
      {
        "id": "A13.16",
        "title": "Webhook secret'lar"
      },
      {
        "id": "A13.17",
        "title": "Provayder kalitlari (to'lov)"
      },
      {
        "id": "A13.18",
        "title": "OAuth ilovalar"
      },
      {
        "id": "A13.19",
        "title": "Kalit siyosati (muddat, murakkablik)"
      },
      {
        "id": "A13.20",
        "title": "Kalit auditi"
      }
    ]
  },
  {
    "key": "A14",
    "num": 14,
    "title": "Feature flag va remote config",
    "count": 16,
    "screens": [
      {
        "id": "A14.01",
        "title": "Flag'lar ro'yxati"
      },
      {
        "id": "A14.02",
        "title": "Flag kartasi"
      },
      {
        "id": "A14.03",
        "title": "Yoqish/o'chirish"
      },
      {
        "id": "A14.04",
        "title": "Bosqichma-bosqich rollout (%)"
      },
      {
        "id": "A14.05",
        "title": "Segment bo'yicha (davlat, versiya, platforma)"
      },
      {
        "id": "A14.06",
        "title": "Kill switch (favqulodda o'chirish)"
      },
      {
        "id": "A14.07",
        "title": "Bog'liqliklar grafi"
      },
      {
        "id": "A14.08",
        "title": "O'zgarishlar jurnali"
      },
      {
        "id": "A14.09",
        "title": "A/B testlar ro'yxati"
      },
      {
        "id": "A14.10",
        "title": "Test konfiguratsiyasi"
      },
      {
        "id": "A14.11",
        "title": "Test natijalari (statistik ahamiyat)"
      },
      {
        "id": "A14.12",
        "title": "Remote config qiymatlari"
      },
      {
        "id": "A14.13",
        "title": "Config versiyalari va rollback"
      },
      {
        "id": "A14.14",
        "title": "Config sxemasi validatsiyasi"
      },
      {
        "id": "A14.15",
        "title": "Klientga tarqatish holati"
      },
      {
        "id": "A14.16",
        "title": "Config diff ko'ruvchi"
      }
    ]
  },
  {
    "key": "A15",
    "num": 15,
    "title": "Bildirishnomalar va broadcast",
    "count": 22,
    "screens": [
      {
        "id": "A15.01",
        "title": "Kampaniyalar ro'yxati"
      },
      {
        "id": "A15.02",
        "title": "Yangi kampaniya"
      },
      {
        "id": "A15.03",
        "title": "Auditoriya tanlash"
      },
      {
        "id": "A15.04",
        "title": "Segment konstruktori"
      },
      {
        "id": "A15.05",
        "title": "Xabar muharriri (ko'p tilli)"
      },
      {
        "id": "A15.06",
        "title": "Preview (barcha platformalar)"
      },
      {
        "id": "A15.07",
        "title": "A/B varianti"
      },
      {
        "id": "A15.08",
        "title": "Tasdiqlash oqimi (four-eyes)"
      },
      {
        "id": "A15.09",
        "title": "Test yuborish"
      },
      {
        "id": "A15.10",
        "title": "Tezlik cheklovi (throttle)"
      },
      {
        "id": "A15.11",
        "title": "Yuborishni to'xtatish"
      },
      {
        "id": "A15.12",
        "title": "Yuborish jadvali"
      },
      {
        "id": "A15.13",
        "title": "Yuborish holati (real-time)"
      },
      {
        "id": "A15.14",
        "title": "Yetkazilish statistikasi"
      },
      {
        "id": "A15.15",
        "title": "Ochilish va bosish"
      },
      {
        "id": "A15.16",
        "title": "Obunadan chiqishlar"
      },
      {
        "id": "A15.17",
        "title": "Push provayder holati (FCM/APNs)"
      },
      {
        "id": "A15.18",
        "title": "Push tokenlari salomatligi"
      },
      {
        "id": "A15.19",
        "title": "Tizim xabarlari (majburiy)"
      },
      {
        "id": "A15.20",
        "title": "Xizmat ogohlantirishlari (banner)"
      },
      {
        "id": "A15.21",
        "title": "Shablonlar kutubxonasi"
      },
      {
        "id": "A15.22",
        "title": "Anti-spam siyosati"
      }
    ]
  },
  {
    "key": "A16",
    "num": 16,
    "title": "Analitika va hisobotlar",
    "count": 44,
    "screens": [
      {
        "id": "A16.01",
        "title": "DAU / WAU / MAU"
      },
      {
        "id": "A16.02",
        "title": "Yangi foydalanuvchilar"
      },
      {
        "id": "A16.03",
        "title": "Retention (kohorta)"
      },
      {
        "id": "A16.04",
        "title": "Churn tahlili"
      },
      {
        "id": "A16.05",
        "title": "Faollik heatmap (soat/kun)"
      },
      {
        "id": "A16.06",
        "title": "Platforma bo'yicha"
      },
      {
        "id": "A16.07",
        "title": "Versiya bo'yicha"
      },
      {
        "id": "A16.08",
        "title": "Davlat bo'yicha"
      },
      {
        "id": "A16.09",
        "title": "Til bo'yicha"
      },
      {
        "id": "A16.10",
        "title": "Xabarlar hajmi"
      },
      {
        "id": "A16.11",
        "title": "Chat turlari bo'yicha"
      },
      {
        "id": "A16.12",
        "title": "Sessiya davomiyligi"
      },
      {
        "id": "A16.13",
        "title": "Ekran bo'yicha vaqt"
      },
      {
        "id": "A16.14",
        "title": "Funnel tahlili"
      },
      {
        "id": "A16.15",
        "title": "Funnel konstruktori"
      },
      {
        "id": "A16.16",
        "title": "Voronka taqqoslash"
      },
      {
        "id": "A16.17",
        "title": "Event kashfiyoti"
      },
      {
        "id": "A16.18",
        "title": "Event lug'ati (taksonomiya)"
      },
      {
        "id": "A16.19",
        "title": "Foydalanuvchi yo'li (path)"
      },
      {
        "id": "A16.20",
        "title": "Segment taqqoslash"
      },
      {
        "id": "A16.21",
        "title": "Kohorta konstruktori"
      },
      {
        "id": "A16.22",
        "title": "Prognozlash"
      },
      {
        "id": "A16.23",
        "title": "Daromad dashboard'i"
      },
      {
        "id": "A16.24",
        "title": "ARPU / ARPPU"
      },
      {
        "id": "A16.25",
        "title": "LTV"
      },
      {
        "id": "A16.26",
        "title": "Konversiya voronkasi"
      },
      {
        "id": "A16.27",
        "title": "Kanal o'sishi"
      },
      {
        "id": "A16.28",
        "title": "Viral koeffitsient"
      },
      {
        "id": "A16.29",
        "title": "Referral samaradorligi"
      },
      {
        "id": "A16.30",
        "title": "Premium konversiyasi"
      },
      {
        "id": "A16.31",
        "title": "Stars iqtisodiyoti"
      },
      {
        "id": "A16.32",
        "title": "Reklama daromadi"
      },
      {
        "id": "A16.33",
        "title": "Kanal monetizatsiyasi"
      },
      {
        "id": "A16.34",
        "title": "Bot ekotizimi statistikasi"
      },
      {
        "id": "A16.35",
        "title": "Mini App statistikasi"
      },
      {
        "id": "A16.36",
        "title": "Top botlar/ilovalar"
      },
      {
        "id": "A16.37",
        "title": "Moderatsiya KPI"
      },
      {
        "id": "A16.38",
        "title": "Support KPI"
      },
      {
        "id": "A16.39",
        "title": "Xizmat sifati (SLO/SLI)"
      },
      {
        "id": "A16.40",
        "title": "Hisobot konstruktori"
      },
      {
        "id": "A16.41",
        "title": "Rejalashtirilgan hisobotlar"
      },
      {
        "id": "A16.42",
        "title": "Eksport markazi"
      },
      {
        "id": "A16.43",
        "title": "Ma'lumot lug'ati"
      },
      {
        "id": "A16.44",
        "title": "Metrikalar ta'rifi (single source)"
      }
    ]
  },
  {
    "key": "A17",
    "num": 17,
    "title": "Infratuzilma va monitoring",
    "count": 28,
    "screens": [
      {
        "id": "A17.01",
        "title": "Xizmatlar holati"
      },
      {
        "id": "A17.02",
        "title": "Server ro'yxati"
      },
      {
        "id": "A17.03",
        "title": "Data-markazlar (DC)"
      },
      {
        "id": "A17.04",
        "title": "DC yuklamasi va taqsimoti"
      },
      {
        "id": "A17.05",
        "title": "Foydalanuvchini DC'ga biriktirish"
      },
      {
        "id": "A17.06",
        "title": "Migratsiya boshqaruvi"
      },
      {
        "id": "A17.07",
        "title": "Navbatlar (Horizon)"
      },
      {
        "id": "A17.08",
        "title": "Ishlamayotgan job'lar"
      },
      {
        "id": "A17.09",
        "title": "Cron/rejalashtirilgan vazifalar"
      },
      {
        "id": "A17.10",
        "title": "Xato loglari"
      },
      {
        "id": "A17.11",
        "title": "Sekin so'rovlar"
      },
      {
        "id": "A17.12",
        "title": "API javob vaqtlari"
      },
      {
        "id": "A17.13",
        "title": "Xato darajasi (SLO)"
      },
      {
        "id": "A17.14",
        "title": "DB holati va replikatsiya"
      },
      {
        "id": "A17.15",
        "title": "Kesh holati (Redis)"
      },
      {
        "id": "A17.16",
        "title": "Fayl saqlash (S3/MinIO)"
      },
      {
        "id": "A17.17",
        "title": "CDN holati"
      },
      {
        "id": "A17.18",
        "title": "Media qayta ishlash navbati"
      },
      {
        "id": "A17.19",
        "title": "Backup holati"
      },
      {
        "id": "A17.20",
        "title": "Tiklash testi (restore drill)"
      },
      {
        "id": "A17.21",
        "title": "Deploy tarixi"
      },
      {
        "id": "A17.22",
        "title": "Rollback"
      },
      {
        "id": "A17.23",
        "title": "Migratsiya holati (DB)"
      },
      {
        "id": "A17.24",
        "title": "Incident'lar ro'yxati"
      },
      {
        "id": "A17.25",
        "title": "Incident kartasi"
      },
      {
        "id": "A17.26",
        "title": "Postmortem'lar"
      },
      {
        "id": "A17.27",
        "title": "On-call jadval"
      },
      {
        "id": "A17.28",
        "title": "Status sahifasi boshqaruvi"
      }
    ]
  },
  {
    "key": "A18",
    "num": 18,
    "title": "Xavfsizlik va audit",
    "count": 24,
    "screens": [
      {
        "id": "A18.01",
        "title": "Audit jurnali (barcha amallar)"
      },
      {
        "id": "A18.02",
        "title": "Audit qidiruvi"
      },
      {
        "id": "A18.03",
        "title": "PII kirish jurnali"
      },
      {
        "id": "A18.04",
        "title": "Xodim faoliyati"
      },
      {
        "id": "A18.05",
        "title": "Shubhali xodim faoliyati"
      },
      {
        "id": "A18.06",
        "title": "Four-eyes so'rovlari navbati"
      },
      {
        "id": "A18.07",
        "title": "JIT huquq so'rovlari"
      },
      {
        "id": "A18.08",
        "title": "Break-glass jurnali"
      },
      {
        "id": "A18.09",
        "title": "Xavfsizlik incident'lari"
      },
      {
        "id": "A18.10",
        "title": "Risk skoring dvigateli"
      },
      {
        "id": "A18.11",
        "title": "Anti-fraud qoidalari"
      },
      {
        "id": "A18.12",
        "title": "Firibgarlik holatlar"
      },
      {
        "id": "A18.13",
        "title": "Anomaliya aniqlash"
      },
      {
        "id": "A18.14",
        "title": "Bot fermalari aniqlash"
      },
      {
        "id": "A18.15",
        "title": "Ommaviy ro'yxatdan o'tish hujumi"
      },
      {
        "id": "A18.16",
        "title": "Kredensial stuffing"
      },
      {
        "id": "A18.17",
        "title": "DDoS holati"
      },
      {
        "id": "A18.18",
        "title": "WAF qoidalari"
      },
      {
        "id": "A18.19",
        "title": "IP qora/oq ro'yxatlari"
      },
      {
        "id": "A18.20",
        "title": "Zaiflik skanerlari"
      },
      {
        "id": "A18.21",
        "title": "Bog'liqliklar auditi"
      },
      {
        "id": "A18.22",
        "title": "Penetratsiya testi natijalari"
      },
      {
        "id": "A18.23",
        "title": "Compliance holati (SOC2/ISO)"
      },
      {
        "id": "A18.24",
        "title": "Xavfsizlik siyosatlari"
      }
    ]
  },
  {
    "key": "A19",
    "num": 19,
    "title": "Huquqiy so'rovlar",
    "count": 16,
    "screens": [
      {
        "id": "A19.01",
        "title": "So'rovlar ro'yxati"
      },
      {
        "id": "A19.02",
        "title": "So'rov kartasi"
      },
      {
        "id": "A19.03",
        "title": "Huquqiy asos tekshiruvi"
      },
      {
        "id": "A19.04",
        "title": "Yurisdiksiya"
      },
      {
        "id": "A19.05",
        "title": "Favqulodda so'rovlar (hayotga xavf)"
      },
      {
        "id": "A19.06",
        "title": "Ma'lumot saqlash buyrug'i (preservation)"
      },
      {
        "id": "A19.07",
        "title": "Kontent o'chirish talablari"
      },
      {
        "id": "A19.08",
        "title": "Bloklash talablari"
      },
      {
        "id": "A19.09",
        "title": "Ma'lumot to'plash"
      },
      {
        "id": "A19.10",
        "title": "Javob tayyorlash"
      },
      {
        "id": "A19.11",
        "title": "Yuborish va tasdiqlash"
      },
      {
        "id": "A19.12",
        "title": "Rad etilgan so'rovlar"
      },
      {
        "id": "A19.13",
        "title": "Shaffoflik hisoboti"
      },
      {
        "id": "A19.14",
        "title": "GDPR so'rovlari"
      },
      {
        "id": "A19.15",
        "title": "Ma'lumot eksporti (subyekt so'rovi)"
      },
      {
        "id": "A19.16",
        "title": "\"Unutilish huquqi\" so'rovlari"
      }
    ]
  },
  {
    "key": "A20",
    "num": 20,
    "title": "Reklama",
    "count": 20,
    "screens": [
      {
        "id": "A20.01",
        "title": "Reklamachilar"
      },
      {
        "id": "A20.02",
        "title": "Reklamachi kartasi"
      },
      {
        "id": "A20.03",
        "title": "Balans va to'lovlar"
      },
      {
        "id": "A20.04",
        "title": "Kampaniyalar"
      },
      {
        "id": "A20.05",
        "title": "Kreativlar moderatsiyasi"
      },
      {
        "id": "A20.06",
        "title": "Taqiqlangan kategoriyalar"
      },
      {
        "id": "A20.07",
        "title": "Targeting sozlamalari"
      },
      {
        "id": "A20.08",
        "title": "Kanal ro'yxati (joylashtirish)"
      },
      {
        "id": "A20.09",
        "title": "Kanalni reklamadan chiqarish"
      },
      {
        "id": "A20.10",
        "title": "Kampaniya tasdiqlash"
      },
      {
        "id": "A20.11",
        "title": "Kampaniya statistikasi"
      },
      {
        "id": "A20.12",
        "title": "Reklama joylashuvlari"
      },
      {
        "id": "A20.13",
        "title": "Narxlash (CPM)"
      },
      {
        "id": "A20.14",
        "title": "Auksion sozlamalari"
      },
      {
        "id": "A20.15",
        "title": "Kanal daromadi taqsimoti"
      },
      {
        "id": "A20.16",
        "title": "Reklama shikoyatlari"
      },
      {
        "id": "A20.17",
        "title": "Firibgar reklamalar"
      },
      {
        "id": "A20.18",
        "title": "Brand safety"
      },
      {
        "id": "A20.19",
        "title": "Reklama hisobotlari"
      },
      {
        "id": "A20.20",
        "title": "Reklama siyosati"
      }
    ]
  },
  {
    "key": "A21",
    "num": 21,
    "title": "Kontent katalogi",
    "count": 18,
    "screens": [
      {
        "id": "A21.01",
        "title": "Stiker to'plamlari"
      },
      {
        "id": "A21.02",
        "title": "Stiker moderatsiyasi"
      },
      {
        "id": "A21.03",
        "title": "Trending stikerlar"
      },
      {
        "id": "A21.04",
        "title": "Mualliflik shikoyatlari"
      },
      {
        "id": "A21.05",
        "title": "Stiker mualliflari"
      },
      {
        "id": "A21.06",
        "title": "Animatsion stikerlar (TGS) validatsiyasi"
      },
      {
        "id": "A21.07",
        "title": "Custom emoji to'plamlari"
      },
      {
        "id": "A21.08",
        "title": "Emoji statuslar"
      },
      {
        "id": "A21.09",
        "title": "Reaksiyalar boshqaruvi"
      },
      {
        "id": "A21.10",
        "title": "Emoji moderatsiyasi"
      },
      {
        "id": "A21.11",
        "title": "Tanlangan (featured) katalog"
      },
      {
        "id": "A21.12",
        "title": "Mini App katalogi"
      },
      {
        "id": "A21.13",
        "title": "Katalog kategoriyalari"
      },
      {
        "id": "A21.14",
        "title": "Tavsiya algoritmi sozlamalari"
      },
      {
        "id": "A21.15",
        "title": "Qidiruv reytingi"
      },
      {
        "id": "A21.16",
        "title": "Media saqlash statistikasi"
      },
      {
        "id": "A21.17",
        "title": "Dublikat media aniqlash"
      },
      {
        "id": "A21.18",
        "title": "Katalog hisobotlari"
      },
      {
        "id": "A21.19",
        "title": "Musiqa kutubxonasi (moderatsiya)"
      }
    ]
  },
  {
    "key": "A22",
    "num": 22,
    "title": "Lokalizatsiya",
    "count": 14,
    "screens": [
      {
        "id": "A22.01",
        "title": "Tillar ro'yxati"
      },
      {
        "id": "A22.02",
        "title": "Til paketlari"
      },
      {
        "id": "A22.03",
        "title": "Kalitlar ro'yxati"
      },
      {
        "id": "A22.04",
        "title": "Tarjima muharriri"
      },
      {
        "id": "A22.05",
        "title": "Yetishmayotgan tarjimalar"
      },
      {
        "id": "A22.06",
        "title": "Pluralizatsiya qoidalari"
      },
      {
        "id": "A22.07",
        "title": "Versiyalash va tarqatish"
      },
      {
        "id": "A22.08",
        "title": "Ommaviy tarjima (jamoa)"
      },
      {
        "id": "A22.09",
        "title": "Tarjimon huquqlari"
      },
      {
        "id": "A22.10",
        "title": "Sifat nazorati"
      },
      {
        "id": "A22.11",
        "title": "Import/eksport (XLIFF, PO)"
      },
      {
        "id": "A22.12",
        "title": "Kontekst skrinshotlari"
      },
      {
        "id": "A22.13",
        "title": "Glossariy"
      },
      {
        "id": "A22.14",
        "title": "Tarjima statistikasi"
      }
    ]
  },
  {
    "key": "A23",
    "num": 23,
    "title": "Xodimlar va tashkilot",
    "count": 18,
    "screens": [
      {
        "id": "A23.01",
        "title": "Xodimlar ro'yxati"
      },
      {
        "id": "A23.02",
        "title": "Xodim kartasi"
      },
      {
        "id": "A23.03",
        "title": "Rollar boshqaruvi"
      },
      {
        "id": "A23.04",
        "title": "Huquqlar matritsasi"
      },
      {
        "id": "A23.05",
        "title": "Rol yaratish/tahrirlash"
      },
      {
        "id": "A23.06",
        "title": "Huquq berish so'rovlari"
      },
      {
        "id": "A23.07",
        "title": "JIT huquqlar"
      },
      {
        "id": "A23.08",
        "title": "Jamoalar"
      },
      {
        "id": "A23.09",
        "title": "Navbatga tayinlash qoidalari"
      },
      {
        "id": "A23.10",
        "title": "Ish vaqti va smenalar"
      },
      {
        "id": "A23.11",
        "title": "Yuklama taqsimoti"
      },
      {
        "id": "A23.12",
        "title": "Samaradorlik ko'rsatkichlari"
      },
      {
        "id": "A23.13",
        "title": "Onboarding checklist"
      },
      {
        "id": "A23.14",
        "title": "Offboarding (huquqlarni olib tashlash)"
      },
      {
        "id": "A23.15",
        "title": "Xodim faoliyati auditi"
      },
      {
        "id": "A23.16",
        "title": "Ichki e'lonlar"
      },
      {
        "id": "A23.17",
        "title": "O'quv materiallari"
      },
      {
        "id": "A23.18",
        "title": "Xodim sozlamalari"
      }
    ]
  },
  {
    "key": "A24",
    "num": 24,
    "title": "Tizim sozlamalari",
    "count": 22,
    "screens": [
      {
        "id": "A24.01",
        "title": "Umumiy sozlamalar"
      },
      {
        "id": "A24.02",
        "title": "Brending (logo, ranglar)"
      },
      {
        "id": "A24.03",
        "title": "Domenlar konfiguratsiyasi"
      },
      {
        "id": "A24.04",
        "title": "Email sozlamalari (SMTP)"
      },
      {
        "id": "A24.05",
        "title": "SMS provayderlar"
      },
      {
        "id": "A24.06",
        "title": "Push sertifikatlari"
      },
      {
        "id": "A24.07",
        "title": "Fayl saqlash sozlamalari"
      },
      {
        "id": "A24.08",
        "title": "CDN sozlamalari"
      },
      {
        "id": "A24.09",
        "title": "Qidiruv indeksi"
      },
      {
        "id": "A24.10",
        "title": "Kesh boshqaruvi"
      },
      {
        "id": "A24.11",
        "title": "Ro'yxatdan o'tish sozlamalari"
      },
      {
        "id": "A24.12",
        "title": "Media limitlari"
      },
      {
        "id": "A24.13",
        "title": "Xabar limitlari"
      },
      {
        "id": "A24.14",
        "title": "Guruh/kanal limitlari"
      },
      {
        "id": "A24.15",
        "title": "Bot limitlari (`bot-limits`)"
      },
      {
        "id": "A24.16",
        "title": "Premium paketlari"
      },
      {
        "id": "A24.17",
        "title": "Narxlar"
      },
      {
        "id": "A24.18",
        "title": "Qonuniy hujjatlar (ToS, Privacy)"
      },
      {
        "id": "A24.19",
        "title": "Hujjat versiyalari va roziliklar"
      },
      {
        "id": "A24.20",
        "title": "Texnik ishlar rejimi"
      },
      {
        "id": "A24.21",
        "title": "Konfiguratsiya eksport/import"
      },
      {
        "id": "A24.22",
        "title": "O'zgarishlar tarixi"
      }
    ]
  },
  {
    "key": "A25",
    "num": 25,
    "title": "Anti-fraud va risk",
    "count": 16,
    "screens": [
      {
        "id": "A25.01",
        "title": "Risk dashboard"
      },
      {
        "id": "A25.02",
        "title": "Qoidalar dvigateli"
      },
      {
        "id": "A25.03",
        "title": "Qoida yaratish"
      },
      {
        "id": "A25.04",
        "title": "Qoida testi (backtest)"
      },
      {
        "id": "A25.05",
        "title": "ML risk modellari"
      },
      {
        "id": "A25.06",
        "title": "Skoring sozlamalari"
      },
      {
        "id": "A25.07",
        "title": "Shubhali hodisalar navbati"
      },
      {
        "id": "A25.08",
        "title": "Avtomatik choralar"
      },
      {
        "id": "A25.09",
        "title": "Qurilma barmoq izlari"
      },
      {
        "id": "A25.10",
        "title": "Bog'liq akkauntlar grafi"
      },
      {
        "id": "A25.11",
        "title": "Sun'iy faollik aniqlash"
      },
      {
        "id": "A25.12",
        "title": "To'lov firibgarligi"
      },
      {
        "id": "A25.13",
        "title": "Stars firibgarligi"
      },
      {
        "id": "A25.14",
        "title": "Referral suiiste'moli"
      },
      {
        "id": "A25.15",
        "title": "Qora ro'yxatlar"
      },
      {
        "id": "A25.16",
        "title": "Firibgarlik hisobotlari"
      }
    ]
  },
  {
    "key": "A26",
    "num": 26,
    "title": "Avtomatlashtirish",
    "count": 12,
    "screens": [
      {
        "id": "A26.01",
        "title": "Ish jarayonlari ro'yxati"
      },
      {
        "id": "A26.02",
        "title": "Workflow konstruktori"
      },
      {
        "id": "A26.03",
        "title": "Shartlar va amallar"
      },
      {
        "id": "A26.04",
        "title": "Test rejimi"
      },
      {
        "id": "A26.05",
        "title": "Bajarilish jurnali"
      },
      {
        "id": "A26.06",
        "title": "Xato holatlar"
      },
      {
        "id": "A26.07",
        "title": "Rejalashtirilgan vazifalar"
      },
      {
        "id": "A26.08",
        "title": "Trigger'lar"
      },
      {
        "id": "A26.09",
        "title": "Webhook'lar (chiquvchi)"
      },
      {
        "id": "A26.10",
        "title": "Integratsiyalar"
      },
      {
        "id": "A26.11",
        "title": "Skriptlar (sandbox)"
      },
      {
        "id": "A26.12",
        "title": "Avtomatlashtirish auditi"
      }
    ]
  },
  {
    "key": "A27",
    "num": 27,
    "title": "Dasturchi vositalari",
    "count": 14,
    "screens": [
      {
        "id": "A27.01",
        "title": "API konsoli"
      },
      {
        "id": "A27.02",
        "title": "So'rov inspektori"
      },
      {
        "id": "A27.03",
        "title": "Webhook debug"
      },
      {
        "id": "A27.04",
        "title": "Update ko'ruvchi"
      },
      {
        "id": "A27.05",
        "title": "Event oqimi (jonli)"
      },
      {
        "id": "A27.06",
        "title": "Xato izlash (trace)"
      },
      {
        "id": "A27.07",
        "title": "Sandbox muhiti"
      },
      {
        "id": "A27.08",
        "title": "Sinov foydalanuvchilari"
      },
      {
        "id": "A27.09",
        "title": "Ma'lumot generatori"
      },
      {
        "id": "A27.10",
        "title": "Migratsiya vositalari"
      },
      {
        "id": "A27.11",
        "title": "Kesh tozalash"
      },
      {
        "id": "A27.12",
        "title": "Xizmat qayta ishga tushirish"
      },
      {
        "id": "A27.13",
        "title": "Konfiguratsiya diff"
      },
      {
        "id": "A27.14",
        "title": "Sog'liq tekshiruvi"
      }
    ]
  },
  {
    "key": "A28",
    "num": 28,
    "title": "Shaxsiy va yordam",
    "count": 6,
    "screens": [
      {
        "id": "A28.01",
        "title": "Mening profilim"
      },
      {
        "id": "A28.02",
        "title": "Xavfsizlik sozlamalari (2FA, qurilmalar)"
      },
      {
        "id": "A28.03",
        "title": "Bildirishnoma sozlamalari"
      },
      {
        "id": "A28.04",
        "title": "Interfeys sozlamalari (til, mavzu, zichlik)"
      },
      {
        "id": "A28.05",
        "title": "Yordam va qo'llanma"
      },
      {
        "id": "A28.06",
        "title": "Klaviatura yorliqlari"
      }
    ]
  }
]

export const TOTAL_SCREENS = MODULES.reduce((n, m) => n + m.screens.length, 0)
export const moduleByKey = (k: string): ModuleDef | undefined => MODULES.find((m) => m.key === k)
